var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.items),function(item,index){return _c('navbar-item',{key:index,attrs:{"level":0,"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }